module.exports = __webpack_public_path__ + "static/media/contact-image1.fa65c1fc.jpg";